import moment from 'moment';

class ContractsManager {
  constructor(data, type) {
    this.data = data.sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.type = type;
    this.formattedData = this.formatData();
  }

  formatData = () => {
    var list = [];
    let yearstrs = [];
    list = list.concat(this.data).map((contract) => {
      const currentDate = Date.parse(new Date());
      const start_date = Date.parse(contract.start_date);
      const end_date = Date.parse(contract.end_date);

      let text = '';
      if (currentDate >= start_date && currentDate <= end_date && !yearstrs.some(v => v.includes('Current')) ) {
        text = `Current (${moment(contract.start_date).format("MMM ‘YY") + ' - ' + moment(contract.end_date).format("MMM ‘YY")})`;
      } else if (
        currentDate > end_date &&
        (currentDate - end_date) / (1000 * 3600 * 24) < 366 &&
        !yearstrs.some(v => v.includes('Previous'))
      ) {
        text = `Previous (${moment(contract.start_date).format("MMM ‘YY") + ' - ' + moment(contract.end_date).format("MMM ‘YY")})`;
      } else {
        text = moment(contract.start_date).format("MMM ‘YY") + ' - ' + moment(contract.end_date).format("MMM ‘YY");
      }
      yearstrs.push(text);
      return {
        text,
        contract_id: contract.id,
        is_running_contract: text.includes('Current'),
        is_overall_contract: false,
        total_customers: contract.total_customers,
        start_date: contract.start_date,
        end_date: contract.end_date,
        enable_health_checks: contract.enable_health_checks,
        enable_doctor_consultations: contract.enable_doctor_consultations,
        enable_pharmacy: contract.enable_pharmacy,
        enable_gym: contract.enable_gym,
        enable_vaccination: contract.enable_vaccination,
        enable_health_coach: contract.enable_health_coach,
        enable_hra: contract.enable_hra,
        enable_spending_account: contract.enable_spending_account,
        total_registered_customers: contract.total_registered_customers,
        enable_dental_checks: contract.enable_dental_checks,
        enable_vision_checks: contract.enable_vision_checks
      };
    });

    const startDate = list.length > 0 ? list[list.length - 1].start_date : ''
    const endDate = list.length > 0 ? list[0].end_date : ''

    if (['HEALTH_CHECKS', 'DOCTOR_CONSULTATION', 'DENTAL', 'VISION', 'VACCINATION'].includes(this.type) && list.length > 1) list.push({ text: 'Overall', start_date: startDate, end_date: endDate, is_overall_contract: true })
    return list;
  };
}

export default ContractsManager;
